import RangeChangedPayload from "@/entities/scheduler/RangeChangedPayload";
import moment from "moment";

export default (
  queryStartTime: Date,
  queryEndTime: Date,
  rangeChangedEvent: RangeChangedPayload
) => {
    const goForward = rangeChangedEvent.end > queryEndTime;
    const goBackwards = rangeChangedEvent.start < queryStartTime;
    if (!goForward && !goBackwards) {
      return undefined;
    }
    if (goForward) {
      const newStart = queryEndTime;
      queryEndTime = moment(rangeChangedEvent.end).add(2, "w").toDate();
      return {
        queryEndTime,
        queryStartTime,
        whereDatesConditions: [
          {
            start_date: {
              _gte: newStart,
              _lte: queryEndTime
            }
          },
          {
            end_date: {
              _gte:newStart,
              _lte: queryEndTime
            }
          },
          {
            _and: [
              {
                start_date: {
                  _lte: newStart,
                }
              },
              {
                end_date: {
                  _gte: queryEndTime
                }
              }
            ]
          }
        ]
      }
    }

    if (goBackwards) {
      const newEnd = queryStartTime;
      queryStartTime = moment(rangeChangedEvent.start).subtract(2, "w").toDate();
      return {
        queryEndTime,
        queryStartTime,
        whereDatesConditions: [
          {
            start_date: {
              _gte: queryStartTime,
              _lte: newEnd,
            }
          },
          {
            end_date: {
              _gte: queryStartTime,
              _lte: newEnd,
            }
          },
          {
            _and: [
              {
                start_date: {
                _lte: queryStartTime
              },
                end_date: {
                  _gte: newEnd,
                }
              }
            ]
          }
        ]
      }
    }
  }